import React, { ChangeEvent, Dispatch, SetStateAction, useEffect } from 'react'

import { Col, Row } from 'react-bootstrap'
import { PagaloCredentials } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/PagaloCredentials'
import { PagaloAdmin } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/PagaloAdmin'
import { PagaloBusiness } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/PagaloBusiness'
import { PagaloFiles } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/PagaloFiles'
import { useDispatch } from 'react-redux'
import { getAccounts } from 'src/actions/banks.actions'

export interface IDataForm {
  data: Partial<IPagaloForm>
  setData?: Dispatch<SetStateAction<IPagaloForm>>
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

export const CardPagaloForm = ({ data, setData }: IDataForm) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAccounts())
  }, [])

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target

    setData(prev => ({ ...prev, [name]: value }))
  }

  return (
    <Row>
      <Col xl={12}>
        <PagaloCredentials data={data} onChange={onChange} />
      </Col>

      <Col xl={12}>
        <PagaloAdmin data={data} onChange={onChange} />
      </Col>

      <Col xl={12}>
        <PagaloBusiness data={data} onChange={onChange} setData={setData} />
      </Col>

      <Col xl={12}>
        <PagaloFiles data={data} onChange={onChange} setData={setData} />
      </Col>
    </Row>
  )
}
